import * as React from 'react';
import { Platform, Text, View, StyleSheet } from 'react-native';
import * as AppUtilities from "../context/AppUtilities";
import * as AppConstants from "../context/AppConstants";
import * as AppState from "../context/AppState";
import { AppContext } from "../context/AppContext";
import { Divider } from 'react-native-paper';
import { CustomScrollView } from '../components/CustomScrollView';
import { CustomButton } from '../components/CustomButton';
import { TextInput } from 'react-native-paper';
import { useForm, Controller } from "react-hook-form";

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    padding: 20,
  },
  heading: {
    fontSize: 18,
    fontWeight: "bold",
  },
  label: {
    fontSize: 14,
    fontWeight: "bold",
    paddingBottom: 10,
  },
  labelPadLeft: {
    fontSize: 14,
    fontWeight: "bold",
    paddingLeft: 5,
  },
  normal: {
    fontSize: 14,
    paddingRight: 10,
    flexShrink: 1,
  },
  divider: {
    marginVertical: 15,
  },
  line: {
    paddingBottom: 15,
    flexWrap: "wrap",
  },
  listItemStyle: {
    paddingLeft: 5,
  }
});

export function Contact({ navigation }) {
  const { showPermanentSnack, showTemporarySnack, hideSnack, getLoginState, showSpinner, hideSpinner } = React.useContext(AppContext);

  const { register, control, handleSubmit, setValue, reset, formState: { errors } } = useForm({
    defaultValues: {
      email: "",
      details: "",
    }
  });

  async function onSubmit(data) {
    try {
      showSpinner();
      hideSnack();

      await AppUtilities.fetchUnauthorized(
        "Contact.onSubmit",
        "/find_humane/api/contact",
        "POST",
        {
          email: data.email,
          data: data.details,
          subject: "Find Humane Contact",
        }
      );

      showTemporarySnack("Thanks! We'll review soon.");

      reset();

      navigation.pop();

    } catch (e) {
      showPermanentSnack(AppUtilities.getErrors(e), "Retry", () => onSubmit(data));
      AppUtilities.handleException(e, "Contact.onSubmit");
    } finally {
      hideSpinner();
    }

  }

  async function onValidationErrors(errors) {
    showTemporarySnack("There are some errors in the form");
  }

  return (
    <CustomScrollView>
      <Text selectable={true} style={styles.normal}>Contact us with comments, questions, or suggestions:</Text>
      <Divider style={AppConstants.STYLES.marginVertical10} />

      <Controller
        control={control}
        name="email"
        rules={{
          required: true,
        }}
        render={({ field: { onChange, onBlur, value } }) => (
          <TextInput
            label="Your email"
            value={value}
            onChangeText={onChange}
            style={AppConstants.STYLES.width100PmarginVertical10borderNone}
            mode="outlined"
            dense={true}
            returnKeyType="next"
            onBlur={onBlur}
            autoComplete="email"
            keyboardType="email-address"
            textContentType="emailAddress"
          />
        )}
      />
      {errors.email && <Text selectable={true} style={AppConstants.STYLES.fontBoldColorRed}>Email is required.</Text>}

      <Controller
        control={control}
        name="details"
        rules={{
          required: true,
        }}
        render={({ field: { onChange, onBlur, value } }) => (
          <TextInput
            label="Comments, questions, or suggestions"
            value={value}
            onChangeText={onChange}
            style={AppConstants.STYLES.width100PmarginVertical10borderNoneMinHeight}
            mode="outlined"
            dense={true}
            returnKeyType="send"
            onBlur={onBlur}
            multiline={true}
            numberOfLines={5}
            textAlignVertical="top"
          />
        )}
      />
      {errors.details && <Text selectable={true} style={AppConstants.STYLES.fontBoldColorRed}>Comments, questions, or suggestions required.</Text>}

      <CustomButton
        onPress={handleSubmit(onSubmit, onValidationErrors)}
        style={AppConstants.STYLES.paddingVertical10}
      >Submit</CustomButton>

    </CustomScrollView>
  );
}
